<template>
  <agent-default>
    <div class="activity-page">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <header class="activity-header">
        <div>
          <h1 class="activity-title">Activity</h1>
          <p class="activity-subtitle">Saved quotes you can resume and complete.</p>
        </div>
        <div class="activity-header-actions">
          <button type="button" class="activity-refresh" :disabled="refreshing" @click="refreshQuotes">
            <v-icon small color="#184679">{{ refreshing ? 'mdi-loading mdi-spin' : 'mdi-refresh' }}</v-icon>
            Refresh
          </button>
          <router-link :to="{ name: 'AgentProductSelect' }" class="activity-link">
            <v-icon small color="#184679">mdi-plus</v-icon>
            New quote
          </router-link>
        </div>
      </header>

      <quotes
        ref="quotes"
        audience="agent"
        :show-filters="true"
        :paginated="true"
        :page-size="10"
      />
    </div>
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import Quotes from '@/components/quotes/Quotes';

export default {
  name: 'AgentQuotes',
  components: { Quotes, BreadCrumb, AgentDefault },
  data() {
    return {
      refreshing: false,
      breadcrumbs: [
        { text: 'Underwriting', disabled: false, to: { name: 'AgentConversions' } },
        { text: 'Activity', disabled: true, to: { name: 'AgentQuotes' } },
      ],
    };
  },
  metaInfo: {
    title: 'Activity',
  },
  methods: {
    async refreshQuotes() {
      this.refreshing = true;
      try {
        await this.$store.dispatch('portalCache/fetchAgentQuotes', { force: true });
      } finally {
        this.refreshing = false;
      }
    },
  },
};
</script>

<style scoped>
.activity-page {
  width: 100%;
  padding: 1.5rem 2rem;
}

.activity-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin: 1.25rem 0 1.5rem;
  flex-wrap: wrap;
}

.activity-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.activity-refresh {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 700;
  color: #184679;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.activity-refresh:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #94a3b8;
}

.activity-refresh:disabled {
  opacity: 0.6;
  cursor: default;
}

.activity-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 4px;
}

.activity-subtitle {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
}

.activity-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  font-weight: 700;
  color: #184679;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 8px 14px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.activity-link:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}
</style>
